import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserTemplateComponent } from './components/user-template/user-template.component';
import { HomeComponent } from './components/home/home.component';
import { LearnMoreComponent } from './components/learn-more/learn-more.component';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { CrisisCardComponent } from './components/crisis-card/crisis-card.component';
import { FaqComponent } from './components/faq/faq.component';
import { StressorsComponent } from './components/stressors/stressors.component';
import { PhonePipe } from 'src/app/pipes/phone.pipe';
import { CarouselModule } from 'primeng/carousel';
import { LayoutModule } from '@angular/cdk/layout';
import { SafePipe } from '../../pipes/safe.pipe';
import { CrisisCardsSectionComponent } from './components/crisis-cards-section/crisis-cards-section.component';
import { AppDownloadComponent } from './components/app-download/app-download.component';
import { AppDownloadOverlayComponent } from './components/app-download-overlay/app-download-overlay.component';
import { UnsubscribeComponent } from './components/unsubscribe/unsubscribe.component';
import { EmailPreviewComponent } from './components/email-preview/email-preview.component';

const routes: Routes = [
	{ path: "", component: UserTemplateComponent, children: [
		//{ path: "learn-more/:path", component: LearnMoreComponent, data: { activeLink: 'learn-more' } },
		{ path: "learn-more", component: LearnMoreComponent, data: { activeLink: 'learn-more' } },
		{ path: "video/:vimeoId", component: HomeComponent, data: { activeLink: 'home' } },
		{ path: "", component: HomeComponent, data: { activeLink: 'home' } },
		{ path: "home", component: HomeComponent, data: { activeLink: 'home' } },

	]},
	{ path: "unsubscribe/:email", component: UnsubscribeComponent },
	{ path: "email-preview/:campaignID/:employerID", component: EmailPreviewComponent },
];

@NgModule({
  declarations: [
    UserTemplateComponent,
    HomeComponent,
    LearnMoreComponent,
    CrisisCardComponent,
    FaqComponent,
    StressorsComponent,

	PhonePipe,
    SafePipe,
    CrisisCardsSectionComponent,
    AppDownloadComponent,
    AppDownloadOverlayComponent,
    UnsubscribeComponent,
    EmailPreviewComponent
  ],
  imports: [
    CommonModule,
	RouterModule.forChild(routes),

	SharedModule,

	CarouselModule,
	LayoutModule,
  ],
  exports: [
    EmailPreviewComponent,
    UnsubscribeComponent
  ]
})
export class UserModule { }
